import { EPropertyType } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';
import { type IApplicationState } from '../../types/redux';

export const selectComparisonAlbums = (state: IApplicationState) => state.comparisonAlbums;

/**
 * В мобильной версии в сравнении доступны только ЖК, поэтому берём единственный подходящий альбом.
 */
export const selectNewbuildingComparisonAlbum = (state: IApplicationState) =>
  state.comparisonAlbums.albums.find(album => album.propertyType === EPropertyType.Newbuilding) || null;
